module.exports = __webpack_public_path__ + "assets/img/Large_1.6e858e12.svg";